import {useMemo} from 'react';
import {Condition} from '@legit.health/ui';
import {Autocomplete, TextField} from '@mui/material';
import {TFunction} from 'i18next';
import {NO_CONDITION} from '@/shared/components/diagnosticReport/DiagnosticReportForm/const/noCondition';
import {ConditionSelectItem} from '@/shared/components/patient/condition/ConditionSelector';
import NewConditionItem from './components/NewConditionItem';

export default function ConditionSelector({
  selectedConditionId,
  conditions,
  onSelectCondition,
  t
}: {
  selectedConditionId: string | null;
  conditions: Condition[];
  onSelectCondition: (conditionId: string | null) => void;
  t: TFunction;
}) {
  const options = useMemo(
    () => [
      ...conditions,
      {
        id: NO_CONDITION
      }
    ],
    [conditions]
  );

  const selectedOption = options.find((option) => `${option.id}` === selectedConditionId);

  return (
    <Autocomplete
      options={options}
      autoHighlight
      onChange={(_, newValue) => onSelectCondition(newValue ? `${newValue.id}` : null)}
      value={selectedOption ?? null}
      getOptionLabel={(option) => {
        if (option.id === NO_CONDITION) {
          return t('shared/common:diagnosticReport.form.selectPathology.newPathology');
        } else {
          const condition = option as Condition;
          return t('shared/common:condition', {
            pathology: condition.pathology.name,
            bodySite: condition.bodySite.name.toLowerCase()
          });
        }
      }}
      getOptionKey={(option) => `${option.id}`}
      renderOption={(props, option) => {
        const {key, ...liProps} = props;
        if (option.id === NO_CONDITION) {
          return <NewConditionItem key="-1" liProps={liProps} t={t} />;
        } else {
          return (
            <ConditionSelectItem key={key} condition={option as Condition} liProps={liProps} />
          );
        }
      }}
      renderInput={(params) => <TextField {...params} label={t('shared/common:selectPathology')} />}
    />
  );
}
